import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const processColdefs = [
    {
        field: "sR.No",
        headerName: "Sr No",
        // minWidth: window.innerWidth * 0.08,
        flex: 0.5,
        filter: true,
    },
    {
        field: "processDetails",
        headerName: "Process details",
        // minWidth: window.innerWidth * 0.08,
        flex: 1.5,
        filter: true,
    },

];

export const ProductBOMSetupPopup = (props) => {
    return (
        <ModalBasic
            id="itemWiseProcess"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Product details</span>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200'>
                    <div className='input-grp'>
                        <label>BOM from</label>
                        <MultiSelectDropdown
                            drpIdentity="Select BOM"
                            options={props.productObject.BOMFromList}
                            value={props.productObject.BOMFromId ? props.productObject.BOMFromList.find(x => x.value === props.productObject.BOMFromId) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "BOMFromId")
                            }
                            className={props.validState?.error?.BOMFromId !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Old product</label>
                        <MultiSelectDropdown
                            drpIdentity="Select product"
                            options={props.productObject.oldProductList}
                            value={props.productObject.oldProductID ? props.productObject.oldProductList.find(x => x.value === props.productObject.oldProductID) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "oldProductID")
                            }
                            className={props.validState?.error?.oldProductID !== undefined ? "error" : ""}
                            isDisabled={props.productObject.oldProductList.length > 0 ? false : true}
                        //isDisabled={true}
                        />
                    </div>
                    <div className='input-grp col-start-1'>
                        <label>Select type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.productObject.types.filter(x => x.value != 1)}
                            value={props.productObject.itemTypeId ? props.productObject.types.find(x => x.value === props.productObject.itemTypeId) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "itemTypeId")
                            }
                            className={props.validState?.error?.itemTypeId !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-start-2 col-span-2'>
                        <label>Select item</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select item"
                            options={props.productObject.itemList}
                            value={props.productObject.itemId ? props.productObject.itemList.find(x => x.value === props.productObject.itemId) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "itemId")
                            }
                            className={props.validState?.error?.itemId !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="SelectItem"
                            name="SelectItem"
                            value={props.productObject.itemIdLabel}
                            handleOnClick={(event) => props.handleOnClick(event, "itemList")}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-3'>

                    <div className='input-grp'>
                        <label>Select type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.productObject.types}
                            value={props.productObject.itemTypeId2 ? props.productObject.types.find(x => x.value === props.productObject.itemTypeId2) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "itemTypeId2")
                            }
                            className={props.validState?.error?.itemTypeId2 !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select item</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select item"
                            options={props.productObject.itemList2}
                            value={props.productObject.itemId2 ? props.productObject.itemList2.find(x => x.value === props.productObject.itemId2) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "itemId2")
                            }
                            className={props.validState?.error?.itemId2 !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="SelectItem"
                            name="SelectItem"
                            value={props.productObject.itemId2Label}
                            handleOnClick={(event) => props.handleOnClick(event, "itemList2")}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.productObject.drawingNo}
                            handleChange={(event) => props.handleChange(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                            disabled={true}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.productObject.quantity}
                            handleChange={(event) => props.handleChange(event, 'quantity')}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        {props.productObject.keyId > 0 ?
                            <>
                                <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Update")}>Update</button>
                                <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.clear()}>Delete</button>
                            </>
                            :
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }

                    </div>
                </div>
                <div className="process-table h-[30vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.productObject.processRowData}
                            columnDefs={props.productObject.processColdefs}
                            onCellClicked={props.handleCellClickItemList}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}